import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Notification} from '../notifications.model';


@Component({
  selector: 'app-notification-dialogue',
  templateUrl: './notification-dialogue.component.html',
  styleUrls: ['./notification-dialogue.component.scss']
})
export class NotificationDialogueComponent implements OnInit {
  notification: Notification;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.notification = this.data.notification;
  }

  ngOnInit(): void {
  }

}
